import { UpdateAdminUserRequest, UpdateConsulteeRequest, useUpdateConsultee } from 'api';

type UseManageTeamRowProps = {
  updateUser: (
    isAdmin: boolean,
    user: UpdateAdminUserRequest,
    onSuccess: () => void,
    onFailure: () => void
  ) => void;
  isUpdatingUser: boolean;
};

export const useManageTeamRow = (): UseManageTeamRowProps => {
  const { mutate: updateConsultee, isLoading: isUpdatingConsultee } = useUpdateConsultee();

  const onUpdateConsultee = (
    data: UpdateConsulteeRequest,
    onSuccess: () => void,
    onFailure: () => void
  ) => {
    updateConsultee(data, {
      onSuccess: () => {
        onSuccess();
      },
      onError: () => {
        onFailure();
      },
    });
  };

  const updateUser = (
    isAdmin: boolean,
    user: UpdateAdminUserRequest,
    onSuccess: () => void,
    onFailure: () => void
  ) => onUpdateConsultee(user, onSuccess, onFailure);

  return {
    updateUser,
    isUpdatingUser: isUpdatingConsultee,
  };
};
